module.exports = __webpack_public_path__ + "static/img/anxin.bfa0051f.jpg";